module.exports = __webpack_public_path__ + "static/media/ic-link.0ecc05f4.png";